import React from 'react';

import { generateClient } from 'aws-amplify/api';

import { DeleteChatMessageInfo } from '../../graphql/API';
import { onAdminDeleteChatMessage } from '../../graphql/subscriptions';
import { GqlError, getError, getErrorFromResult, processGqlResult } from '../../utils/gql-utils';

const client = generateClient();

export const useOnAdminDeleteChatMessageListener = (
  messageTime?: string,
  conversationId?: string,
) => {
  const [message, setMessage] = React.useState<Nullable<DeleteChatMessageInfo>>(null);
  const [error, setErorr] = React.useState<GqlError>();

  React.useEffect(() => {
    if (messageTime && conversationId) {
      const createSub = client.graphql({
        query: onAdminDeleteChatMessage,
        variables: { messageTime, conversationId },
      }).subscribe({
        next: ({ data }: { data: { onAdminDeleteChatMessage: DeleteChatMessageInfo } }) => {
          const _message = processGqlResult<DeleteChatMessageInfo>('onAdminDeleteChatMessage', { data });
          setMessage(_message);
          const errorFromResponse = getErrorFromResult({ data });

          if (errorFromResponse) {
            throw errorFromResponse;
          }
        },
        error: (ex) => {
          const raisedError = getError(ex);
          console.error(raisedError);
          setErorr(raisedError);
        },
      });

      return () => {
        createSub.unsubscribe();
      };
    }
  }, [setMessage, conversationId, messageTime]);

  return {
    message,
    error,
  };
};
